const $ = jQuery.noConflict()

var self = module.exports = {
  init: function(trigger) {
    self.events.click(trigger)
    self.events.clickOutside(trigger)
  },

  events: {
    click: function(trigger) {
      $(document).on('click', trigger, function() {
        self.service.bodyClass($(this))
      })
    },
    clickOutside: function(trigger) {
      $(document).on("click", function(event) {
       
        var target = $(event.target)

        if ($(target).closest('.header').length) {
        } else {
          $('.sub-menu').removeClass('show')
          $('.header__nav .menu-item-has-children').removeClass('show')
        }
      })
    }
  },

  service: {
    bodyClass: function(target) {
      if($(target).is("#nav-toggle")) {
        $('body').addClass('prevent-scroll')
      } else {
        $('body').removeClass('prevent-scroll')
      }
     
    }
  }
}
